import styled from "styled-components";

export const Container = styled.div`
  width: 60%;
  max-width: 640px;
  margin-left: 6%;
`;
